<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99935 4.0013V2.66797M7.99935 4.0013C7.26297 4.0013 6.66602 4.59826 6.66602 5.33464C6.66602 6.07101 7.26297 6.66797 7.99935 6.66797M7.99935 4.0013C8.73573 4.0013 9.33268 4.59826 9.33268 5.33464C9.33268 6.07101 8.73573 6.66797 7.99935 6.66797M3.99935 12.0013C4.73573 12.0013 5.33268 11.4043 5.33268 10.668C5.33268 9.93159 4.73573 9.33464 3.99935 9.33464M3.99935 12.0013C3.26297 12.0013 2.66602 11.4043 2.66602 10.668C2.66602 9.93159 3.26297 9.33464 3.99935 9.33464M3.99935 12.0013V13.3346M3.99935 9.33464V2.66797M7.99935 6.66797V13.3346M11.9993 12.0013C12.7357 12.0013 13.3327 11.4043 13.3327 10.668C13.3327 9.93159 12.7357 9.33464 11.9993 9.33464M11.9993 12.0013C11.263 12.0013 10.666 11.4043 10.666 10.668C10.666 9.93159 11.263 9.33464 11.9993 9.33464M11.9993 12.0013V13.3346M11.9993 9.33464V2.66797"
      stroke="#B2B2B2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {};
</script>
